export default __webpack_public_path__ + "static/media/ac_mode_cool_active.541f4bfd.svg";